<template>
  <div class="main-container">
    <div class="header">
      <div class="nav-item" @click="$router.push('/systemmanager/system')">
        <div class="txt">
          账号管理
        </div>
      </div>
      <div
        class="nav-item"
        @click="$router.push('/systemmanager/systemExperiment')"
      >
        <span>
          成绩管理
        </span>
      </div>
      <div
        class="nav-item active"
        @click="$router.push('/systemmanager/systemTotal')"
      >
        <div class="txt">
          历史记录
        </div>
      </div>
    </div>
    <div class="search-wrap">
      <el-row :gutter="2" style="width: 100%">
        <el-col :span="20">
          <span style="font-size: 16px;font-weight: bolder;color: #9fa19f"
            >时间查询：</span
          >
          <el-date-picker
            value-format="timestamp"
            v-model="value1"
            type="daterange"
            range-separator="~"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="4">
          <div class="btn">
            <button @click="search">
              搜索 search
            </button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="main">
      <div class="table-wrap">
        <el-table
          :data="list"
          border
          size="small"
          header-cell-class-name="my-header"
          style="width: 100%;"
        >
          <el-table-column
            align="center"
            min-width="100"
            show-overflow-tooltip
            label="项目名称"
          >
            <template>
              电商选品虚拟仿真实验
            </template>
          </el-table-column>
          <el-table-column
            prop="see"
            align="center"
            min-width="100"
            show-overflow-tooltip
            label="浏览量"
          >
          </el-table-column>
          <el-table-column
            prop="student"
            align="center"
            min-width="100"
            show-overflow-tooltip
            label="学习人数"
          >
          </el-table-column>
          <el-table-column
            prop="experiment"
            align="center"
            min-width="100"
            show-overflow-tooltip
            label="完成实训（次）"
          >
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value1: "",
      list: [],
      list2: [],
      searchParams: {
        pagination: {
          pageNo: 1,
          pageSize: 10,
          type: true,
          total: 0,
        },
        student: {
          userName: "",
          realName: "",
          studentNo: "",
          className: "",
          schoolName: "",
        },
      },
      totalData: {
        student: 0,
        experiment: 0,
      },
    };
  },
  created() {
    this.search();
  },
  methods: {
    search() {
      let origin = {
        see: 0,
        student: 0,
        experiment: 0,
      };
      const type = this.value1[0] && this.value1[1];
      Promise.all([this.getList(), this.getList2()]).then((res) => {
        origin.student = res[0].items.reduce((accumulator, obj) => {
          if (
            (obj.register > this.value1[0] && obj.register < this.value1[1]) ||
            !type
          ) {
            return accumulator + 1;
          } else {
            return accumulator;
          }
        }, 0);
        origin.experiment = res[1].items.reduce((accumulator, obj) => {
          if (
            (obj.createTime > this.value1[0] &&
              obj.createTime < this.value1[1]) ||
            !type
          ) {
            return accumulator + 1;
          } else {
            return accumulator;
          }
        }, 0);
        origin.see = parseInt(origin.experiment * 2.36);
        this.list = [];
        this.list.push(origin);
      });
    },
    getList() {
      return new Promise((resolve) => {
        this.$axios
          .post("/manager/student/list", {
            pagination: {
              pageNo: 1,
              pageSize: 99999,
              type: true,
              total: 0,
            },
            student: {
              userName: "",
              realName: "",
              studentNo: "",
              className: "",
              schoolName: "",
            },
          })
          .then((res) => {
            if (res.succeed) {
              resolve(res);
            }
          });
      });
    },
    getList2() {
      return new Promise((resolve) => {
        this.$axios
          .post("/manager/experiment/list", {
            pagination: {
              pageNo: 1,
              pageSize: 9999,
              type: true,
              total: 0,
            },
            experiment: {
              student: {
                userName: "",
                realName: "",
                studentNo: "",
                className: "",
                schoolName: "",
              },
            },
          })
          .then((res) => {
            if (res.succeed) {
              resolve(res);
            }
          });
      });
    },
    isBlur(type) {
      switch (type) {
        case true:
          document.querySelector("#app").classList.add("blur");
          break;
        case false:
          document.querySelector("#app").classList.remove("blur");
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.main-container {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  min-width: 300px;
  background: #ffffff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
  border-radius: 12px;

  .header {
    display: flex;
    height: 96px;
    line-height: 96px;
    background: linear-gradient(360deg, #005be7 0%, #70a0eb 100%);
    opacity: 1;
    border-radius: 12px 12px 0px 0px;
    font-size: 30px;
    font-weight: 400;
    color: #ffffff;
    padding: 0 20%;

    div.nav-item {
      cursor: pointer;
      width: 50%;
      text-align: center;

      div.txt {
        padding: 0 20px;
        display: inline-block;
        height: 96px;
        position: relative;
        font-weight: 400;
      }

      &.active {
        .txt {
          font-weight: bold;
        }

        .txt:before {
          content: "";
          position: absolute;
          bottom: 1px;
          left: 0;
          width: 100%;
          height: 8px;
          background: white;
        }
      }
    }
  }

  .search-wrap {
    width: 100%;
    padding: 24px 24px 0 24px;
    display: flex;

    .input {
      input {
        width: 100%;
        font-family: "Microsoft YaHei", sans-serif;
        height: 48px;
        background: #f2f2f2;
        opacity: 1;
        border-radius: 12px;
        font-size: 18px;
        color: #999999;
        padding: 0 20px;
      }
    }

    .btn {
      button {
        width: 100%;
        height: 48px;
        background: linear-gradient(
          90deg,
          rgba(119, 166, 239, 0.97) 0%,
          #005be7 100%
        );
        box-shadow: 0px 1px 4px rgba(119, 166, 239, 0.97);
        opacity: 1;
        border-radius: 60px;
        font-size: 20px;
        font-family: Microsoft YaHei UI, sans-serif;
        font-weight: 400;
        line-height: 22px;
        color: #ffffff;
        text-transform: uppercase;
      }
    }
  }

  .main {
    height: calc(100% - 168px);
    padding: 24px;

    ::v-deep .my-header {
      background: #70a0eb;
      font-size: 18px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      color: #ffffff;
    }

    ::v-deep .el-table--small {
      font-size: 14px;
    }

    .table-wrap {
      border-radius: 8px;
      height: calc(100% - 130px);
      overflow: hidden;
    }

    @media screen and (max-width: 1600px) {
      .pagination-wrap {
        flex-direction: column;

        .tea-pagination {
          align-self: flex-start;
        }

        .handler-wrap {
          align-self: flex-end;
        }
      }
    }

    .pagination-wrap {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .handler-wrap {
        button {
          width: 153px;
          height: 44px;
          background: linear-gradient(315deg, #005be7 0%, #70a0eb 100%);
          opacity: 1;
          border-radius: 60px;
          color: white;
          margin-right: 12px;

          &:last-child {
            margin-right: 0;
          }

          div:nth-child(1) {
            font-size: 18px;
            line-height: 18px;
            font-family: "Microsoft YaHei", sans-serif;
            margin-bottom: 2px;
          }

          div:nth-child(2) {
            font-size: 10px;
            line-height: 10px;
            font-family: "Microsoft YaHei", sans-serif;
            letter-spacing: -0.5px;
          }
        }
      }
    }
  }
}

.add-modal {
  .title {
    padding: 0 12px;

    .text {
      height: 33px;
      font-size: 26px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: bold;
      line-height: 33px;
      color: #454b60;
    }

    .sub-text {
      height: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      line-height: 15px;
      color: #999999;
      text-transform: uppercase;
    }
  }

  ::v-deep .el-form-item {
    width: calc(50% - 36px);

    &:nth-child(even) {
      margin-right: 62px;
    }

    .el-form-item__label {
      font-size: 18px;
      line-height: 18px;
    }

    .el-input__inner {
      height: 54px;
      background: #ffffff;
      border: 2px solid #f1f1f1;
      border-radius: 12px;
      line-height: 54px;
    }
  }
}

.import-modal {
  .title {
    padding: 0 12px;

    .text {
      height: 33px;
      font-size: 26px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: bold;
      line-height: 33px;
      color: #454b60;
    }

    .sub-text {
      height: 15px;
      font-size: 12px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      line-height: 15px;
      color: #999999;
      text-transform: uppercase;
    }
  }

  .content {
    .label {
      height: 23px;
      font-size: 18px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      line-height: 23px;
      color: #999999;
      margin-bottom: 8px;
    }

    .uploader-wrap {
      display: flex;
      margin-bottom: 20px;

      .uploader-btn {
        cursor: pointer;
        width: 476px;
        height: 54px;
        padding: 0 24px;
        line-height: 54px;
        font-size: 22px;
        font-weight: 400;
        color: #999999;
        background: #ffffff;
        border: 2px solid #f1f1f1;
        opacity: 1;
        border-radius: 12px;
        margin-right: 18px;
      }
    }

    .info {
      text-align: center;
      height: 23px;
      font-size: 18px;
      font-family: Microsoft YaHei UI, serif;
      font-weight: 400;
      line-height: 23px;
      color: #999999;
      margin-bottom: 28px;

      span {
        color: #70a0eb;
      }
    }
  }

  .footer {
    text-align: center;
  }
}
</style>
